/* Lost Herbal theme behaviour. Every feature works without this file; it only adds polish. */
(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  /* Mobile menu */
  $$('[data-lh-menu]').forEach((btn) => {
    const drawer = document.getElementById(btn.getAttribute('aria-controls'));
    if (!drawer) return;
    btn.addEventListener('click', () => {
      const open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      drawer.hidden = open;
    });
    $$('a', drawer).forEach((a) => a.addEventListener('click', () => {
      btn.setAttribute('aria-expanded', 'false');
      drawer.hidden = true;
    }));
  });

  /* Announcement countdown, only when the merchant sets a real end date */
  $$('[data-lh-countdown]').forEach((el) => {
    const end = Date.parse(el.dataset.end || '');
    if (!end) return;
    const parts = { h: $('[data-h]', el), m: $('[data-m]', el), s: $('[data-s]', el) };
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      const left = Math.max(0, end - Date.now());
      if (!left) { el.hidden = true; return; }
      const total = Math.floor(left / 1000);
      parts.h.textContent = pad(Math.floor(total / 3600));
      parts.m.textContent = pad(Math.floor((total % 3600) / 60));
      parts.s.textContent = pad(total % 60);
      el.hidden = false;
      setTimeout(tick, 1000 - (Date.now() % 1000));
    };
    tick();
  });

  /* Offer: the selected bundle and the Remedy Vault trial choice drive every CTA on the page. The free books show as
     included when the bundle comes with them, and their buttons switch to that bundle otherwise. */
  const offerEl = $('script[data-lh-offer]');
  if (offerEl) {
    let offer;
    try { offer = JSON.parse(offerEl.textContent); } catch (e) { offer = null; }
    if (offer && offer.tiers && offer.tiers.length) {
      const state = {
        key: (offer.tiers.find((t) => t.key === offer.defaultKey) || offer.tiers[0]).key,
        trial: true,
      };
      const free = offer.free || {};
      const freeBox = $('[data-lh-free]');
      const giftTier = offer.tiers.find((t) => t.gifts);
      const passthrough = new URLSearchParams();
      new URLSearchParams(location.search).forEach((v, k) => {
        if (/^(utm_|fbclid$|gclid$|ttclid$|ref$|aff)/.test(k)) passthrough.set(k, v);
      });
      const tier = () => offer.tiers.find((t) => t.key === state.key) || offer.tiers[0];
      const href = () => {
        const url = new URL(offer.checkoutUrl, location.href);
        url.searchParams.set('item', state.key);
        url.searchParams.set('trial', state.trial ? '1' : '0');
        if (state.cur) url.searchParams.set('cur', state.cur);
        passthrough.forEach((v, k) => url.searchParams.set(k, v));
        return url.toString();
      };
      const render = () => {
        const t = tier();
        $$('[data-lh-cta]').forEach((a) => { a.href = href(); });
        $$('[data-lh-cta-price]').forEach((s) => { s.textContent = t.price; });
        if (freeBox) {
          const included = Boolean(t.gifts);
          freeBox.classList.toggle('is-included', included);
          freeBox.classList.toggle('is-locked', !included);
          $$('[data-lh-free-word]', freeBox).forEach((w) => { w.textContent = included ? free.word : free.lockedWord; });
          const kicker = $('[data-lh-free-kicker]', freeBox);
          const text = $('[data-lh-free-text]', freeBox);
          if (kicker) kicker.textContent = included ? free.kicker : free.lockedKicker;
          if (text) text.textContent = included ? free.text : free.lockedText;
          $$('[data-lh-addon-tag]', freeBox).forEach((tag) => { tag.hidden = !included; });
          $$('[data-lh-addon-switch]', freeBox).forEach((b) => { b.hidden = included; });
        }
        $$('[data-lh-tier-name]').forEach((s) => { s.textContent = t.name; });
        $$('[data-lh-trialnote]').forEach((n) => { n.innerHTML = state.trial ? offer.notes.trial : offer.notes.once; });
        $$('[data-lh-trial-toggle]').forEach((b) => {
          b.textContent = state.trial ? offer.toggle.trial : offer.toggle.once;
          b.setAttribute('aria-pressed', String(!state.trial));
        });
        $$('[data-lh-gifts]').forEach((g) => { g.hidden = !state.trial; });
      };
      $$('input[name="lh-tier"]').forEach((input) => {
        if (input.checked) state.key = input.value;
        input.addEventListener('change', () => { if (input.checked) { state.key = input.value; render(); } });
      });
      $$('[data-lh-trial-toggle]').forEach((b) => b.addEventListener('click', () => { state.trial = !state.trial; render(); }));
      $$('[data-lh-addon-switch]').forEach((b) => b.addEventListener('click', () => {
        if (tier().gifts || !giftTier) return;
        const input = $(`input[name="lh-tier"][value="${giftTier.key}"]`);
        if (!input) return;
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        input.focus({ preventScroll: true });
      }));
      render();

      /* Local prices: the checkout says which currency this buyer pays in (from their location, or ?cur= on the
         page) and its fixed prices. Every USD amount on the page switches to it, and the checkout link carries it. */
      const wanted = new URLSearchParams(location.search).get('cur') || '';
      fetch(`${new URL(offer.checkoutUrl, location.href).origin}/api/prices${wanted ? `?cur=${encodeURIComponent(wanted)}` : ''}`, { credentials: 'omit' })
        .then((r) => (r.ok ? r.json() : null))
        .then((p) => {
          if (!p || !p.currency) return;
          state.cur = p.currency.key;
          const fmt = (n) => new Intl.NumberFormat(p.currency.locale, {
            style: 'currency', currency: p.currency.code, minimumFractionDigits: n % 1 === 0 ? 0 : 2, maximumFractionDigits: 2,
          }).format(n);
          // Bundle prices always come from the checkout, whatever currency Shopify rendered them in
          offer.tiers.forEach((t) => { if (p.items[t.key] != null) t.price = fmt(p.items[t.key]); });
          $$('[data-lh-tier-now]').forEach((el) => { const v = p.items[el.dataset.lhTierNow]; if (v != null) el.textContent = fmt(v); });
          if (p.currency.key !== 'usd') {
            const local = new Map(p.amounts.map(([usd, amount]) => [Number(usd).toFixed(2), fmt(amount)]));
            const swap = (text) => String(text).replace(/\$(\d{1,4}(?:\.\d{2})?)(?![\d.])/g, (m, n) => local.get(Number(n).toFixed(2)) || m);
            offer.notes.trial = swap(offer.notes.trial);
            offer.notes.once = swap(offer.notes.once);
            const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
              acceptNode: (n) => (/\$\d/.test(n.nodeValue) && !n.parentElement.closest('script, style, noscript')
                ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT),
            });
            const nodes = [];
            while (walker.nextNode()) nodes.push(walker.currentNode);
            nodes.forEach((n) => { n.nodeValue = swap(n.nodeValue); });
            $$('[data-lh-currency-note]').forEach((el) => { el.textContent = `Prices in ${p.currency.code}`; el.hidden = false; });
            document.documentElement.dataset.currency = p.currency.code;
          }
          render();
        })
        .catch(() => { /* prices stay in USD */ });
    }
  }

  /* Product gallery: scroll snap track, thumbs and arrows stay in sync */
  $$('[data-lh-gallery]').forEach((root) => {
    const track = $('[data-lh-track]', root);
    const thumbs = $$('[data-lh-thumb]', root);
    const rail = $('[data-lh-rail]', root);
    if (!track) return;
    const count = track.children.length;
    let current = 0;
    const vertical = () => rail && getComputedStyle(rail).flexDirection.startsWith('column');

    /* Whole thumbs only: the side rail keeps 76px thumbs and stretches the gap so an exact number fit the stage
       height; the mobile row keeps an 8px gap and sizes the thumbs so an exact number fit the width. */
    const fitRail = () => {
      if (!rail || !thumbs.length) return;
      if (vertical()) {
        rail.style.removeProperty('--lh-thumb-size');
        // Whole pixels, so the rail can scroll all the way to the last thumb's bottom edge
        const space = Math.floor(rail.getBoundingClientRect().height), size = thumbs[0].getBoundingClientRect().height, gap = 10;
        const fit = Math.floor((space + gap) / (size + gap));
        if (fit > 1 && fit < thumbs.length) rail.style.setProperty('--lh-thumb-gap', `${Math.floor(((space - fit * size) / (fit - 1)) * 100) / 100}px`);
        else rail.style.removeProperty('--lh-thumb-gap');
      } else {
        rail.style.removeProperty('--lh-thumb-gap');
        const space = rail.getBoundingClientRect().width, gap = 8;
        const fit = Math.min(thumbs.length, Math.max(1, Math.floor((space + gap) / (60 + gap))));
        rail.style.setProperty('--lh-thumb-size', `${Math.min(88, Math.floor(((space - (fit - 1) * gap) / fit) * 100) / 100)}px`);
      }
    };
    if (rail && 'ResizeObserver' in window) new ResizeObserver(fitRail).observe(rail);
    fitRail();

    /* Keep the active thumb in view, moving the rail only as far as needed so it stays on whole thumbs */
    const showThumb = (thumb) => {
      const v = vertical();
      const start = v ? thumb.offsetTop : thumb.offsetLeft;
      const end = start + (v ? thumb.offsetHeight : thumb.offsetWidth);
      const from = v ? rail.scrollTop : rail.scrollLeft;
      const view = v ? rail.clientHeight : rail.clientWidth;
      let to = from;
      if (start < from) to = start;
      else if (end > from + view) to = end - view;
      if (to !== from) rail.scrollTo({ [v ? 'top' : 'left']: to, behavior: 'smooth' });
    };
    const setActive = (i) => {
      current = i;
      thumbs.forEach((t, n) => t.setAttribute('aria-current', String(n === i)));
      if (thumbs[i] && rail) showThumb(thumbs[i]);
    };
    /* While a click scrolls the track, the slides it passes don't move the active thumb back */
    let target = null, settle;
    const go = (i) => {
      const n = (i + count) % count;
      target = n;
      clearTimeout(settle);
      settle = setTimeout(() => { target = null; }, 900);
      track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' });
      setActive(n);
    };
    thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
    $('[data-lh-prev]', root)?.addEventListener('click', () => go(current - 1));
    $('[data-lh-next]', root)?.addEventListener('click', () => go(current + 1));
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        if (target !== null) {
          if (i === target) target = null;
          return;
        }
        if (i !== current) setActive(i);
      });
    }, { passive: true });
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
    });
  });

  /* Look inside viewer */
  $$('[data-lh-viewer]').forEach((root) => {
    const slides = $$('[data-lh-slide]', root);
    const label = $('[data-lh-viewer-label]', root);
    if (slides.length < 2) return;
    let current = 0;
    const show = (i) => {
      current = (i + slides.length) % slides.length;
      slides.forEach((s, n) => s.setAttribute('aria-hidden', String(n !== current)));
      if (label) label.textContent = slides[current].dataset.label || '';
    };
    $('[data-lh-viewer-prev]', root)?.addEventListener('click', () => show(current - 1));
    $('[data-lh-viewer-next]', root)?.addEventListener('click', () => show(current + 1));
    root.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') show(current + 1);
      if (e.key === 'ArrowLeft') show(current - 1);
    });
    const stage = $('[data-lh-viewer-stage]', root);
    let startX = null;
    stage?.addEventListener('pointerdown', (e) => { startX = e.clientX; });
    stage?.addEventListener('pointerup', (e) => {
      if (startX === null) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
      else if (e.pointerType === 'mouse') show(current + 1);
      startX = null;
    });
    show(0);
  });

  /* Sticky bar appears once the main buy button has scrolled away */
  const sticky = $('[data-lh-sticky]');
  const anchor = $('[data-lh-buy-cta]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    const closer = $('[data-lh-closer]');
    let pastBuy = false;
    let closerOn = false;
    const update = () => sticky.classList.toggle('is-visible', pastBuy && !closerOn);
    new IntersectionObserver(([entry]) => {
      pastBuy = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      update();
    }).observe(anchor);
    if (closer) {
      new IntersectionObserver(([entry]) => { closerOn = entry.isIntersecting; update(); }, { threshold: .25 }).observe(closer);
    }
  }
})();
